var countdownDistance = distanceToTimestamp(pst.sameDayCountdownTime, pst.sameDaySkipMondays);

window.addEventListener('load', function(){
  watchPreorderLabels();
  fillProductPst();
  fillCartPst();
  fillPstDates();
  fillCartCountdown();
})

let productGrid = document.getElementById('ProductGridContainer');
if (productGrid) {
  productGrid.addEventListener('render', function(){
    fillProductPst();
    fillPstDates();
  });
}

window.updatePst = function() {
  fillProductPst();
  fillCartPst();
  fillPstDates();
  fillCartCountdown();
  watchPreorderLabels();
}

function fillProductPst(){
  // Fill promised ship time messages on products
  if (pst.sameDayShipMessage && countdownDistance > 0) {
    fillPst(
      '.ready-to-ship',
      pst.sameDayShipMessage
    )
  } else if (pst.readyToShipMessage) {
    fillPst(
      '.ready-to-ship',
      pst.readyToShipMessage
    )
  }

  if (pst.madeToOrderMessage) {
    fillPst(
      '.made-to-order',
      pst.madeToOrderMessage
    )
  }

  fillPreorderPst()
}

function fillCartPst(){
  // Fill the cart promised ship time message
  if (pst.cartSameDayCountdownMessage && countdownDistance > 0) {
    fillPst(
      '.cart-items__pst.ready-to-ship',
      pst.cartSameDayCountdownMessage
    )
  } else if (pst.cartReadyToShipMessage) {
    fillPst(
      '.cart-items__pst.ready-to-ship',
      pst.cartReadyToShipMessage
    )
  }

  if (pst.cartMadeToOrderMessage) {
    fillPst(
      '.cart-items__pst.made-to-order',
      pst.cartMadeToOrderMessage
    )
  }

  // The cart subtotal / banner in preorder state is filled by fillPreorderPst(), which
  // fillProductPst() calls. Filling it here too would write .ship-msg twice.
}

/*
* Preorder as a floor
*
* Preorder does not replace the promised ship date, it raises its minimum: the date
* shown is max(future preorder date, READY-TO-SHIP date). See preorderFloorAgainstIso()
* for why the computed side is ready-to-ship and for the one cart-banner exception.
* The element carries the computed status in data-pst-status and the future preorder date
* in data-preorder-date (see the data contract in promised-ship-time.liquid).
* Its CSS class is `preorder`, so the status matchers in fillPst() never match it and
* .ship-msg is written exactly once -- here.
*/

// M/D from a YYYY-MM-DD string, by splitting the string. Never `new Date(iso)`: that
// parses as UTC midnight and renders the previous day in any negative-offset timezone.
function formatShortFromIso(iso) {
  if (!iso) return '';
  let parts = String(iso).split('-');
  if (parts.length < 3) return '';
  return parseInt(parts[1], 10) + '/' + parseInt(parts[2], 10);
}

// The floor itself. Both arguments are zero-padded YYYY-MM-DD -- preorder-iso.liquid
// emits that shape and calculatePromisedShipDate(days, "ISO") returns it from
// store-shifted time -- so a lexical compare is correct and timezone-safe. Doubles as
// a plain max when folding cart lines into one cart-wide date.
function floorIso(preorderIso, computedIso) {
  if (!preorderIso) return computedIso;
  if (!computedIso) return preorderIso;
  return preorderIso > computedIso ? preorderIso : computedIso;
}

// Fill a per-surface message template whose date placeholder survived translation.
function fillPreorderTemplate(template, iso) {
  if (!template) return '';
  return template.split('%DATE%').join(formatShortFromIso(iso));
}

// Promised date for a ready-to-ship scope: today (0 business days) while the same-day
// countdown is still running, otherwise the configured lead time.
function readyToShipIso(sameDayMessage) {
  if (sameDayMessage && countdownDistance > 0) return calculatePromisedShipDate(0, 'ISO');
  return calculatePromisedShipDate(parseInt(pst.readyToShipDays, 10) || 0, 'ISO');
}

// The computed side of the floor.
//
// Rule, decided by Jay Vogt 2026-09-10: a future preorder date floors against the
// READY-TO-SHIP date, and a preorder line never drags the order to made-to-order.
// Flooring against a made-to-order date derived from an item simply having no stock rolled
// the promise forward one day per day (5 business days from TODAY) instead of converging on
// the preorder date -- and being inbound is not a production lead time. Ready-to-ship is
// still real work: it is 1 business day, so a preorder date landing on a weekend or a
// holiday floors up to the next business day.
//
// The one exception is the cart banner. A cart that ALSO holds a genuinely made-to-order
// line -- no preorder date, fails the inventory test -- must still promise that line's
// date, so the banner's computed side is the cart's own made-to-order date and the banner
// shows max(latest preorder date in the cart, that date). Getting this wrong
// under-promises the genuinely slow item.
//
// pst.cartStatus is the authority for "the cart holds a genuinely made-to-order line" on
// both paths: at first paint the footer cart-status loop emits it, skipping future-preorder
// lines, and the updateCartComplete handler rewrites it from cartHasMadeToOrder (which also
// skips them) before any banner date is rendered. The banner element's own data-pst-status
// is NOT usable here -- the cart-subtotal block still folds a zero-stock preorder line into
// its inventory test, so it reads made-to-order even for a preorder-only cart.
function preorderFloorAgainstIso(sameDayMessage, isCartBanner) {
  if (isCartBanner && pst.cartStatus === 'made-to-order') {
    return calculatePromisedShipDate(cartMtoDays(), 'ISO');
  }
  return readyToShipIso(sameDayMessage);
}

function fillPreorderPst() {
  // Product and cart-line scopes always floor against ready-to-ship. Only the cart banner
  // (#pst-banner-message / #pst-subtotal-message, a .cart-items__pst) can floor against a
  // made-to-order date, and only for a genuinely made-to-order line elsewhere in the cart.
  fillPreorderScope('.product__pst[data-preorder-date], .product-card__pst[data-preorder-date]', pst.preorderMessage, pst.sameDayShipMessage, false);
  fillPreorderScope('.cart-item__pst[data-preorder-date]', pst.cartLinePreorderMessage, pst.sameDayShipMessage, false);
  fillPreorderScope('.cart-items__pst[data-preorder-date]', pst.cartPreorderMessage, pst.cartSameDayCountdownMessage, true);
}

function fillPreorderScope(selector, template, sameDayMessage, isCartBanner) {
  document.querySelectorAll(selector).forEach(el => {
    let target = el.querySelector('.ship-msg, .inventory-msg');
    if (target) {
      let display = floorIso(el.dataset.preorderDate, preorderFloorAgainstIso(sameDayMessage, isCartBanner));
      target.innerHTML = fillPreorderTemplate(template, display);
    }
    el.classList.remove('loading');
  });
}

/*
* PDP preorder button label
*
* main-product.js's toggleAddButton rewrites the add-to-cart label to
* theme.strings.addToCart on every variant render, dropping the Pre-Order label Liquid
* painted for first paint. product-info is the PDP wrapper
* (sections/main-product.liquid:49, closed at :896); the button markup is
* <span>LABEL</span><span class="loading-spinner ...">, so the first span is the label.
*
* window.updatePst() was the documented hook for restoring it. On this theme it is NOT
* reached on a same-product variant change: instrumenting window.updatePst on a live PDP
* recorded zero calls, with no console error, while the bundle still rewrote the label.
* renderProductInfo() does carry an updatePst() call, so some other path is doing the
* rewrite. Rather than chase which vendor path wins -- the bundle is upstream output and
* out of bounds -- watch the label and re-assert it.
*
* The observer settles because a write only happens when the text differs. Only an enabled
* button is relabelled, so a sold-out variant keeps the vendor's "Sold out". The
* data-preorder-label attribute is emitted by sections/main-product.liquid only for a
* strictly future preorder date, so a lapsed date can never be relabelled.
*/
function applyPreorderLabelTo(button) {
  if (button.hasAttribute('disabled')) return;
  let label = button.querySelector('span');
  if (!label) return;
  let text = button.dataset.preorderLabel || (window.theme && theme.strings && theme.strings.preOrder);
  if (!text) return;
  if (label.textContent.trim() === text) return;
  label.textContent = text;
}

function applyPreorderLabel() {
  document.querySelectorAll('product-info [name="add"][data-preorder-label]').forEach(applyPreorderLabelTo);
}

// One document-level observer covers every rewrite path: a same-product variant change
// that patches the button in place, and a combined-listing swap that replaces product-info
// outright. Coalesced to a frame, so an unrelated burst of DOM churn costs one pass, and
// each pass is a single attribute-selector query.
function watchPreorderLabels() {
  applyPreorderLabel();
  if (window.__pstPreorderLabelWatcher) return;
  let queued = false;
  window.__pstPreorderLabelWatcher = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; applyPreorderLabel(); });
  });
  window.__pstPreorderLabelWatcher.observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled']
  });
}

function fillPst(selector, content) {
  document.querySelectorAll(selector).forEach(x => {
    if (x.querySelector('.ship-msg')) {
      x.querySelector('.ship-msg').innerHTML = content;
    }
    x.classList.remove('loading')
  })
}

/*
* Per-product-type made-to-order lead times
* Config lives in the mto_lead_time metaobject, emitted as pst.mtoLeadTimes.
* See docs/plans/product-type-mto-lead-times.md
*/

// Pure function over a list of product types. Kept this shape deliberately: the
// deferred bundle-component work only has to pass a longer list, not restructure this.
function resolveMtoDays(productTypes) {
  let days = parseInt(pst.madeToOrderDays, 10) || 0;

  (productTypes || []).forEach(productType => {
    if (!productType) return;

    (pst.mtoLeadTimes || []).forEach(entry => {
      if (entry.type !== productType) return;
      let entryDays = parseInt(entry.days, 10);
      // Duplicate entries for one type resolve to the highest
      if (!isNaN(entryDays) && entryDays > days) days = entryDays;
    });
  });

  return days;
}

// The whole order ships together, so every made-to-order cart line and the cart
// banner quote the longest applicable lead time rather than their own.
function cartMtoDays() {
  return parseInt(pst.cartMadeToOrderDays, 10) || parseInt(pst.madeToOrderDays, 10) || 0;
}

// Product cards and the PDP resolve their own type; anything without a type in
// scope is a cart context and uses the cart-wide value.
function mtoDaysForElement(el) {
  let scope = el.closest('[data-pst-type]');
  if (scope && scope.dataset.pstType) return resolveMtoDays([scope.dataset.pstType]);
  return cartMtoDays();
}

// Does this line currently resolve to made-to-order?
//
// Mirrors the status precedence in promised-ship-time.liquid: when
// metafieldOverride is on, an inventory.status of 'Ready to ship' wins over low
// inventory. Deriving this from inventory alone counts metafield-RTS lines as
// made-to-order, which quotes their type's lead time on an order that has none of
// that type actually made to order.
function lineIsMadeToOrder(totals, line_item) {
  if (pst.metafieldOverride && totals.inventory_status === 'Ready to ship') return false;
  if (totals.product_type === 'Gift Card') return false;
  if (pst.metafieldOverride && totals.inventory_status === 'Made to order') return true;

  let stock = totals.inventory_quantity;
  return stock <= pst.cartInventoryMinimum || line_item.quantity > stock;
}

// A cart line's GUARDED preorder date, read off its rendered badge.
//
// pst.cartInventoryTotals is keyed by variant id and carries no preorder information at
// all. pst.cartPreorderDates -- also keyed by variant id -- is emitted straight from the
// raw descriptors.preorder metafield with NO future-date guard, so a lapsed date is
// indistinguishable from a live one there and a value present in it does NOT mean
// "preorder". The rendered .cart-item__pst is the guarded signal: data-preorder-date is
// emitted (through preorder-iso.liquid) only for a strictly future date. Safe to read in
// the updateCartComplete path because main-cart-items.js re-renders the line items from
// the server before that event fires.
function linePreorderDate(line_item) {
  let div = document.querySelector('[data-cart-item="' + line_item.key + '"]');
  if (!div) return '';
  let pstDiv = div.querySelector('.cart-item__pst');
  if (!pstDiv) return '';
  return pstDiv.dataset.preorderDate || '';
}

// Recompute the cart-wide value from a /cart.js payload after the cart changes.
function recalculateCartMtoDays(cart) {
  let types = [];

  cart.items.forEach(line_item => {
    let totals = pst.cartInventoryTotals[line_item.id];
    if (!totals) return;
    // A future-preorder line is never made to order, so it contributes no product type
    // and no lead time to the cart-wide value.
    if (linePreorderDate(line_item)) return;

    if (lineIsMadeToOrder(totals, line_item) && totals.product_type) {
      types.push(totals.product_type);
    }
  });

  pst.cartMadeToOrderDays = resolveMtoDays(types);
  return pst.cartMadeToOrderDays;
}

function fillPstDates(){
  // Fill promised ship date spans
  if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
    document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{
      x.innerHTML = calculatePromisedShipDate(pst.readyToShipDays)
    })
  }

  if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
    document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{
      x.innerHTML = calculatePromisedShipDate(mtoDaysForElement(x))
    })
  }
}

/*
* Cart same-day shipping countdown
*/
function fillCartCountdown() {
  let cartMessage = document.querySelector("#pst-banner-message, #pst-subtotal-message");

  if (pst.sameDayCountdownTime && cartMessage && cartMessage.querySelector(".countdown")) {
    if (cartMessage && countdownDistance > 0) {
      countdownTimer(
        cartMessage.querySelector(".countdown"),
        cartMessage.dataset.format,
        cartMessage.dataset.time,
        true
      );
  
    } else if (cartMessage.classList.contains("ready-to-ship")) {
      cartMessage.innerHTML = pst.cartReadyToShipMessage;
    } else {
      cartMessage.innerHTML = pst.cartMadeToOrderMessage;
    }
  }
}

/*
* Update messages when ajax cart is changed
*/
let mainCartItems = document.getElementById('main-cart-items');
if (mainCartItems) {
  mainCartItems.addEventListener("updateCartComplete", function () {
    // main-cart-items.js re-renders .cart-items__products (line items) and
    // main-cart-footer (the banner) from the server BEFORE this event fires, so every
    // .cart-item__pst and #pst-banner-message/#pst-subtotal-message element already
    // carries the server-computed data-pst-status (exclusions- and metafield-aware) and,
    // where applicable, data-preorder-date. Don't overwrite those here -- they are read
    // as-is (data-preorder-date by linePreorderDate() and by the folds below).
    getJSON('/cart.js').then(cart => {
      countdownDistance = distanceToTimestamp(pst.sameDayCountdownTime, pst.sameDaySkipMondays);
      // Refresh the cart-wide made-to-order lead time before any date is rendered below
      recalculateCartMtoDays(cart);

      // Collected across the loop and resolved AFTER it. Deciding the banner inside the
      // loop let a later made-to-order line overwrite an earlier line's preorder.
      let cartPreorderDate = null;
      let cartHasMadeToOrder = false;

      cart.items.forEach(function(line_item){
        let totals = pst.cartInventoryTotals[line_item.id];
        // A line added after page load has no entry here. Skip it rather than throwing
        // and aborting the whole recompute -- matches recalculateCartMtoDays().
        if (!totals) return;
        let stock = totals.inventory_quantity;
        let div = document.querySelector('[data-cart-item="'+line_item.key+'"]');
        if (!div) return;
        let pstDiv = div.querySelector('.cart-item__pst');
        if (!pstDiv) return;
        let pstMessage = pstDiv.querySelector('.ship-msg');

        let preorderDate = pstDiv.dataset.preorderDate;
        let lineIsMto = stock <= pst.cartInventoryMinimum || line_item.quantity > stock;
        // A future-preorder line does not contribute to the cart's made-to-order
        // determination, however little stock it has -- see preorderFloorAgainstIso().
        if (lineIsMto && !preorderDate) cartHasMadeToOrder = true;

        if (preorderDate) {
          // floorIso() doubles as a max: fold this line into the cart-wide preorder date
          cartPreorderDate = floorIso(preorderDate, cartPreorderDate);
          pstDiv.classList.add('preorder');
          pstDiv.classList.remove('ready-to-ship', 'made-to-order');
          if (pstMessage) {
            // Same computed side as the first-paint fill for this line: ready-to-ship
            let lineComputed = preorderFloorAgainstIso(pst.sameDayShipMessage, false);
            pstMessage.innerHTML = fillPreorderTemplate(pst.cartLinePreorderMessage, floorIso(preorderDate, lineComputed));
          }
          pstDiv.classList.remove('loading');

        } else if (lineIsMto) {
          pstDiv.classList.add('made-to-order');
          pstDiv.classList.remove('ready-to-ship', 'preorder');
          if (pstMessage) pstMessage.innerHTML = pst.madeToOrderMessage;

        } else if (countdownDistance > 0 && pst.sameDayShipMessage) {
          pstDiv.classList.add('ready-to-ship');
          pstDiv.classList.remove('made-to-order', 'preorder');
          if (pstMessage) pstMessage.innerHTML = pst.sameDayShipMessage;

        } else {
          pstDiv.classList.add('ready-to-ship');
          pstDiv.classList.remove('made-to-order', 'preorder');
          if (pstMessage) pstMessage.innerHTML = pst.readyToShipMessage;
        }
      })

      // A line added after page load has no cartInventoryTotals entry and was skipped
      // above, but its server-rendered badge still carries the date. Fold every rendered
      // badge in so the banner never loses a preorder date the server already knows.
      document.querySelectorAll('.cart-item__pst[data-preorder-date]').forEach(el => {
        cartPreorderDate = floorIso(el.dataset.preorderDate, cartPreorderDate);
      });

      // cartStatus keeps carrying the COMPUTED cart status, exactly as the Liquid emits
      // it; the preorder date rides alongside it rather than replacing it.
      pst.cartStatus = cartHasMadeToOrder ? 'made-to-order' : 'ready-to-ship';
      pst.cartPreorderDate = cartPreorderDate;

      let cartMessage = document.querySelector("#pst-banner-message, #pst-subtotal-message");

      if (cartMessage && cartPreorderDate) {
        cartMessage.classList.add('preorder');
        cartMessage.classList.remove('ready-to-ship', 'made-to-order');
        cartMessage.classList.remove('loading');

        // pst.cartStatus was assigned just above, so this matches the first-paint fill:
        // ready-to-ship unless a genuinely made-to-order line is in the cart.
        let cartComputed = preorderFloorAgainstIso(pst.cartSameDayCountdownMessage, true);
        let bannerMessage = cartMessage.querySelector('.ship-msg');
        if (bannerMessage) {
          bannerMessage.innerHTML = fillPreorderTemplate(pst.cartPreorderMessage, floorIso(cartPreorderDate, cartComputed));
        }

      } else if (cartMessage && pst.cartStatus == 'ready-to-ship') {
        cartMessage.classList.add('ready-to-ship');
        cartMessage.classList.remove('made-to-order', 'preorder');

        if (countdownDistance > 0 ) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartSameDayCountdownMessage;
        } else if (pst.cartReadyToShipMessage) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartReadyToShipMessage;
        }

      } else if (cartMessage && pst.cartStatus == 'made-to-order') {
        cartMessage.classList.add('made-to-order');
        cartMessage.classList.remove('ready-to-ship', 'preorder');

        if (pst.cartMadeToOrderMessage) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartMadeToOrderMessage;
        }

      }

      // Skipped while a preorder date is in scope: this block rewrites .ship-msg from
      // the plain status messages and would clobber the floored preorder date above.
      if (pst.sameDayCountdownTime && !cartPreorderDate) {
        if (countdownDistance > 0 && cartMessage.querySelector(".countdown")) {
          countdownTimer(
            cartMessage.querySelector(".countdown"),
            cartMessage.dataset.format,
            cartMessage.dataset.time,
            true
          );

        } else if (cartMessage.classList.contains("ready-to-ship")) {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartReadyToShipMessage;
        } else {
          cartMessage.querySelector('.ship-msg').innerHTML = pst.cartMadeToOrderMessage;
        }
      }

      if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }

      if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
        document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = calculatePromisedShipDate(mtoDaysForElement(x))});
      }

      if (cart.item_count == 0) cartMessage.classList.add('hidden');
    })

    async function getJSON(path) {
      const response = await fetch(path);
      return await response.json();
    }
  });
}

/*
* Checkout
*/
if (Shopify.Checkout && pst.checkoutStatus) {
  // Customer info page
  if (Shopify.Checkout.step == 'contact_information') {
    let pickUpInStoreField = document.getElementById('checkout_pick_up_in_store_selected')

    if (pickUpInStoreField) {
    sessionStorage.setItem('pick_up_in_store', pickUpInStoreField.value)

    pickUpInStoreField.addEventListener('change', (event) => {
      sessionStorage.setItem('pick_up_in_store', event.currentTarget.value)
      removeLinePst();
      appendLinePst();
      updatePst();
    })
  }
  }

  // Shipping method page
  // Prepend PST to the shipping method content
  if (Shopify.Checkout.step == 'shipping_method') {
    prependShippingPst();
  }

  // Every page except "Thank You" and "Order Status"
  // Append line item PST and fill date/time
  if (Shopify.Checkout.page != 'thank_you' && !Shopify.Checkout.OrderStatus) {
    appendLinePst();
    updatePst();
  }

  if (Shopify.Checkout.step == 'contact_information' || Shopify.Checkout.step == 'shipping_method' || Shopify.Checkout.step == 'payment_method') {
    if (countdownDistance > 0 && pst.checkoutStatus == 'ready-to-ship') {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(0, 'ISO'));
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(pst.readyToShipDays, 'ISO'));
    } else {
      sessionStorage.setItem('pstDate', calculatePromisedShipDate(cartMtoDays(), 'ISO'));
    }
  }

  // Thank you page (first time visit)
  // Update PST metafield and display current PST
  if ( Shopify.Checkout.page == 'thank_you' ) {

    if (!!sessionStorage.getItem('pstDate')) {
      pst.confirmShipDate = sessionStorage.getItem('pstDate');
    } else if (countdownDistance > 0 && pst.checkoutStatus == 'ready-to-ship') {
      pst.confirmShipDate = calculatePromisedShipDate(0, 'ISO');
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      pst.confirmShipDate = calculatePromisedShipDate(pst.readyToShipDays, 'ISO');
    } else {
      pst.confirmShipDate = calculatePromisedShipDate(cartMtoDays(), 'ISO');
    }

    fetch('https://n8n.jnkbr.co/webhook/f16e16d0-e9fd-43df-84c4-cc7656129df8', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        promised_ship_date: pst.confirmShipDate,
        order_id: pst.orderId
      })
    }).then((response) => {
      let p = document.createElement('p');
      p.classList.add('section__text', 'pst-message');
      if (pst.checkoutStatus == 'ready-to-ship') {
        p.innerHTML = pst.readyToShipMessage;
      } else {
        p.innerHTML = pst.madeToOrderMessage;
      }
      let div = document.createElement('div');
      div.classList.add('section__message');
      div.append(p);

      document.querySelector('.section__content').prepend(div);

      if (countdownDistance > 0 && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(0);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }
      if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
        var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
        document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
      }
      if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
        var madeToOrderDate = calculatePromisedShipDate(cartMtoDays());
        document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = madeToOrderDate});
      }

      sessionStorage.removeItem('pstDate');
    })
  }

  // Order status page
  // Prepend PST from order metafield (date retrieved in order-confirmation-scripts)
  if (Shopify.Checkout.OrderStatus && Shopify.Checkout.page != 'thank_you') {
    if (order.metafields.promised_ship_date) {
      let p = document.createElement('p');
      p.classList.add('section__text', 'pst-message');
      p.innerHTML = pst.orderConfirmationMessage;

      let div = document.createElement('div');
      div.classList.add('section__message');
      div.append(p);

      document.querySelector('.section__content').prepend(div);

      if (document.querySelector('.pst_date')) {
        let pstDate = (order.metafields.promised_ship_date.getMonth() + 1) + '/' + order.metafields.promised_ship_date.getDate();
        document.querySelectorAll('.pst_date').forEach(x=>{x.innerHTML = pstDate});
      }
    }

    sessionStorage.removeItem('pstDate');
  }

  // Checkout PST functions
  const contentObserver = new MutationObserver(()=>{
    if (Shopify.Checkout.step == 'shipping_method') {
      prependShippingPst();
      updatePst();
    }
  })

  contentObserver.observe(
    document.querySelector('.main__content'), {
      childList: true
    }
  )

  const lineObserver = new MutationObserver(()=>{
    appendLinePst();
    updatePst();
  })

  lineObserver.observe(
    document.querySelector('.order-summary__sections'), {
      childList: true
    }
  )

  function removeLinePst() {
    document.querySelector('.total-line--shipping-message').remove();
  }

  function appendLinePst(){
    let td = document.createElement('td');
    td.classList.add('total-line__name');
    td.setAttribute('colspan', '2');
    if (sessionStorage.getItem('pick_up_in_store') == 'true') {
      if (countdownDistance > 0 ) {
        td.innerHTML = pst.readyToPickUpMessage;
      }
      if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
        td.innerHTML = pst.sameDayPickUpMessage;
      } else if (pst.checkoutStatus == 'ready-to-ship') {
        td.innerHTML = pst.readyToPickUpMessage;
      } else {
        td.innerHTML = pst.madeToOrderPickUpMessage;
      }
    } else {
      if (countdownDistance > 0 ) {
        td.innerHTML = pst.readyToShipMessage;
      }
      if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
        td.innerHTML = pst.sameDayShipMessage;
      } else if (pst.checkoutStatus == 'ready-to-ship') {
        td.innerHTML = pst.readyToShipMessage;
      } else {
        td.innerHTML = pst.madeToOrderMessage;
      }
    }
    let tr = document.createElement('tr');
    tr.classList.add('total-line', 'total-line--shipping-message', 'pst-message');
    tr.append(td);

    if (!(document.querySelector('.total-line.total-line--shipping.pst-message'))) {
      document.querySelector('.total-line.total-line--shipping').parentNode.append(tr);
    }
  }

  function prependShippingPst(){
    let p = document.createElement('p');
    p.classList.add('section__text', 'pst-message');
    if (pst.checkoutStatus == 'ready-to-ship' && countdownDistance > 0) {
      p.classList.add('ready-to-ship');
      p.innerHTML = pst.sameDayShipMessage;
    } else if (pst.checkoutStatus == 'ready-to-ship') {
      p.classList.add('ready-to-ship');
      p.innerHTML = pst.readyToShipMessage;
    } else {
      p.innerHTML = pst.madeToOrderMessage;
    }

    let div = document.createElement('div');
    div.classList.add('section__message');
    div.append(p);

    if (!(document.querySelector('.section--shipping-method .section__message .pst-message'))) {
      document.querySelector('.section--shipping-method').prepend(div);
    };
  }

  function updatePst() {
    if (countdownDistance > 0 && document.querySelector(".pst-message .countdown")) {
      document.querySelectorAll('.pst-message .countdown').forEach((countdown) => {
        countdownTimer(
          countdown,
          pst.sameDayCountdownFormat,
          pst.sameDayCountdownTime,
          true
        )
      })
    }
    if (pst.readyToShipDays && document.querySelector(".pst_ready_to_ship_date")) {
      var readyToShipDate = calculatePromisedShipDate(pst.readyToShipDays);
      document.querySelectorAll(".pst_ready_to_ship_date").forEach(x=>{x.innerHTML = readyToShipDate});
    }
    if (pst.madeToOrderDays && document.querySelector(".pst_made_to_order_date")) {
      var madeToOrderDate = calculatePromisedShipDate(cartMtoDays());
      document.querySelectorAll(".pst_made_to_order_date").forEach(x=>{x.innerHTML = madeToOrderDate});
    }
  }
}


/*
* Common functions
*/
function getStoreDateTime () {
  const localDate = new Date(); // local time
  const localOffset = localDate.getTimezoneOffset() * 60 * 1000; // local offset in milliseconds
  const utcTime = new Date(localDate.getTime() + localOffset); // calculated utc time
  const junkTime = new Date(utcTime.getTime() + theme.shopTimezoneOffset * 60 * 1000);
  return junkTime;
}

function calculatePromisedShipDate(days, format = "short") {
  function formatDate(date) {
    if (format == "ISO") {
      /* ISO Format is used for systems -- 2022-04-20 */
      return date.getFullYear() + "-" + addLeadingZero(date.getMonth() + 1) + "-" + addLeadingZero(date.getDate());
    } else {
      /* Short format is for display -- 4/20 */
      return date.getMonth() + 1 + "/" + date.getDate();
    }
  }

  function addLeadingZero(number) {
    return ("0" + number).slice(-2);
  }

  var storeTime = getStoreDateTime();
  let calc = 0,
      shipTime = new Date(storeTime.getTime()),
      shipDate = shipTime.getFullYear() + "-" + ("0" + (shipTime.getMonth() + 1)).slice(-2) + "-" + ("0" + shipTime.getDate()).slice(-2)

  while (calc < days) {
    shipTime = new Date(shipTime.getTime() + 86400000); // add 1 day in milliseconds
    shipDate = shipTime.getFullYear() + "-" + ("0" + (shipTime.getMonth() + 1)).slice(-2) + "-" + ("0" + shipTime.getDate()).slice(-2);

    // Skips Sunday, Saturday and JUNK Holidays
    if (shipTime.getDay() !== 0
        && shipTime.getDay() !== 6
        && !theme?.storeHolidays.some((x) => x == shipDate)) {
      calc++;
    }
  }

  return formatDate(shipTime, format);
}

function distanceToTimestamp(time, skipMondays = false) {
  let currentTime = getStoreDateTime(),
      currentDate = currentTime.getFullYear() + "-" + ("0" + (currentTime.getMonth() + 1)).slice(-2) + "-" + ("0" + currentTime.getDate()).slice(-2),
      holidayCheck = theme?.storeHolidays?.some((x) => x == currentDate);

  // [0, 1, 6]
  if ([0, 6].includes(currentTime.getDay()) || holidayCheck || (skipMondays == true && currentTime.getDay() == 1)) {
    return 0;
  }
  let date = new Date(currentDate + "T" + time + ":00.000" + theme.shopTimezone);
  return date.getTime() - new Date().getTime();
}

function countdownTimer (element, format, dateString, partial = false) {
  if (partial) {
    let currentTime = getStoreDateTime(),
        currentDate = currentTime.getFullYear() + "-" + ("0" + (currentTime.getMonth() + 1)).slice(-2) + "-" + ("0" + currentTime.getDate()).slice(-2);
    dateString = new Date(currentDate + "T" + dateString + ":00.000" + theme.shopTimezone);
  }
  element.classList.add("loader-bar");
  // element: A valid object selector name, i.e. '.timer'
  // format: "full" (XX Hours XX Minutes XX Seconds) or "condensed" (XX:XX:XX)
  // dateString example: 2021-11-04T00:00:00.000-07:00

  function formatTime(input, format) {
    let hours = Math.floor(input / (1000 * 60 * 60)).toLocaleString("en-US", { minimumIntegerDigits: 2 });
    let minutes = Math.floor((input % (1000 * 60 * 60)) / (1000 * 60)).toLocaleString("en-US", { minimumIntegerDigits: 2 });
    let seconds = Math.floor((input % (1000 * 60)) / 1000).toLocaleString("en-US", { minimumIntegerDigits: 2 });

    if (format == "extended") {
      let hoursText = hours != "01" ? " hours " : " hour ";
      let minutesText = minutes != "01" ? " minutes " : " minute ";
      let secondsText = seconds != "01" ? " seconds" : " second";

      let hoursString = hours + hoursText;
      let minutesString = minutes + minutesText;
      let secondsString = seconds + secondsText;

      var output = hoursString + minutesString + secondsString;
    } else if (format == "standard") {
      let hoursText = hours != "01" ? " hours " : " hour ";
      let minutesText = minutes != "01" ? " minutes " : " minute ";
      let secondsText = seconds != "01" ? " seconds" : " second";

      let hoursString = parseInt(hours) > 0 ? hours + hoursText : "";
      let minutesString = parseInt(minutes) > 0 ? minutes + minutesText : "";
      let secondsString = parseInt(seconds) > 0 ? seconds + secondsText : "";

      var output = hoursString + minutesString + secondsString;
    } else if (format == "condensed") {
      var output = hours + ":" + minutes + ":" + seconds;
    }

    return output;
  };

  let countDownDate = new Date(dateString);
  let countDownDateTime = countDownDate.getTime();

  let updateTimer = setInterval(function () {
    let now = new Date().getTime();
    let distance = countDownDateTime - now > 0 ? countDownDateTime - now : 0;
    element.innerHTML = formatTime(distance, format);
    element.classList.remove("loader-bar");

    if (distance <= 0) {
      clearInterval(updateTimer);
    }
  }, 1000);
};